<template>
    <div v-loading="loading">
        <div v-if="showModel == 'epcImg'">
            <div class="search-ctn">
                <div class="search-zone">
                    <el-select v-model="searchMode" placeholder="请选择" size="small" @change="modeChange">
                        <el-option key="0" label="零件号" value="0"></el-option>
                        <el-option key="1" label="零件名称" value="1"></el-option>
                    </el-select>
                    <el-input
                        width="280px"
                        size="small"
                        clearable
                        v-model.trim="oeStr"
                        v-filter-special-char="oeStr"
                        :placeholder="searchMode == 0 ? '请输入零件号/OE' : '请输入零件原厂名/配件名称'"
                    ></el-input>
                    <el-button v-if="searchMode == 0" icon="el-icon-search" class="btn-primary" size="small" @click="handleSearch">查询</el-button>
                    <el-button v-if="searchMode == 1" icon="el-icon-search" class="btn-primary" size="small" @click="handleSearch">普通查询</el-button>
                    <el-button v-if="searchMode == 1" type="warning" icon="el-icon-search" class="search-btn" size="small" @click="jzymSearch">精准译码</el-button>
                </div>
            </div>
            <el-container style="height: 650px; margin-top: 10px">
                <el-aside height="100%" style="transition: all 0.3s; margin-bottom: 10px">
                    <el-card class="box-card" style="padding: 10px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree
                            check-strictly
                            highlight-current
                            :data="structureList"
                            :default-expanded-keys="['402880ef0dabc53d010daf2b38520001']"
                            ref="tree"
                            :filter-node-method="filterNode"
                            node-key="Id"
                            :props="treeProps"
                            @node-click="handleNodeClick"
                        >
                            <span class="custom-tree-node" slot-scope="{ node }">
                                <span>{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </el-card>
                </el-aside>
                <el-main
                    v-if="structureImgList.length > 0"
                    height="100%"
                    class="img-zone"
                    style="padding-top: 0px; padding-bottom: 0px; transition: all 0.3s; margin-bottom: 10px"
                >
                    <el-card class="tu-item" v-for="(item, index) in structureImgList" :key="item.Id">
                        <div @click="gotoDetails(item, index)">
                            <div class="qp-cover">
                                <img
                                    :src="
                                        item.CHJImgUrl
                                            ? downloadUrl +
                                              (item.CHJImgUrl.length > 0 ? item.PublicUrl + '?imageView2/2/w/200' : '/UploadFile/Commons/Public/Images/200x200.png')
                                            : item.PicUrl
                                    "
                                    alt=""
                                    :onerror="defaultImg"
                                />
                            </div>
                            <div class="tu-msg">
                                <p class="title" :title="item.PicName">{{ item.PicName.length > 20 ? item.PicName.substring(0, 17) + '...' : item.PicName }}</p>
                            </div>
                        </div>
                    </el-card>
                </el-main>
                <el-main v-if="oeNoImgData.length > 0" height="100%" style="padding-top: 0px; padding-bottom: 0px; transition: all 0.3s; margin-bottom: 10px">
                    <div class="table-ctn">
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="oeNoImgData"
                            ref="oeNoImgTable"
                            border=""
                            style="width: 100%; height: 570px; overflow: auto"
                        >
                            <el-table-column width="80px" prop="OrderNo" label="位置序号" show-overflow-tooltip></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="OEName" label="零件名称"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="Oe" label="零件号（OE）">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.LoadMyOe" icon="el-icon-loading" type="text"></el-button>
                                    <el-popover placement="right" v-model="scope.row.visible" :ref="'pop1_' + scope.row.OEId">
                                        <el-table
                                            class="pop-tb"
                                            style="margin-bottom: 0px"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            border=""
                                            :data="scope.row.MyGoods"
                                        >
                                            <el-table-column show-overflow-tooltip min-width="140" property="APCode" label="编码">
                                                <template slot-scope="scope">
                                                    <el-button class="pop-btn" icon="el-icon-plus" type="round" @click="addToPreOrder(scope.row)"></el-button>
                                                    {{ scope.row.APCode }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column show-overflow-tooltip min-width="100" property="GoodCode" label="互换码"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Origin" label="产地"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Inventory" label="库存数"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="MarketPrice" label="销售价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="CostPrice" label="成本价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingInQuantity" label="待入"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingOutQuantity" label="待出"></el-table-column>
                                        </el-table>
                                        <el-button
                                            class="pop-btn"
                                            type="primary"
                                            slot="reference"
                                            @click="showMyOE(scope.row)"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            >有货</el-button
                                        >
                                    </el-popover>
                                    {{ scope.row.Oe }}
                                </template>
                            </el-table-column>
                            <el-table-column v-if="showOEPrice" show-overflow-tooltip width="170px" label="价格">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.PriceData && scope.row.IsShow" placement="right">
                                        <div slot="content" v-html="$options.filters.priceShowText(scope.row.PriceData)"></div>
                                        <span>{{ scope.row.PriceData.GuidePrice }}</span>
                                    </el-tooltip>
                                    <span v-else>
                                        <el-button @click="getPrices(scope.row)" type="text" style="padding: 0px">获取价格</el-button>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="80px" prop="PartNum" label="装备数量"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="PartRemark" label="更多信息"></el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </el-container>
        </div>
        <div v-if="showModel == 'epcOeData'">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-back" class="back-btn btn-primary" @click="backToImg">返回</el-button>
                    <el-button v-if="currentIndex > 0 && structureList && structureList.length != 1" size="small" type="primary" class="back-btn" @click="lastPic"
                        ><i class="el-icon-d-arrow-left"></i> 上一张</el-button
                    >
                    <div class="title">{{ oeTitle }}</div>
                    <el-button v-if="structureList && currentIndex < structureList.length" size="small" type="primary" class="back-btn" @click="nextPic"
                        >下一张 <i class="el-icon-d-arrow-right"></i
                    ></el-button>
                </div>
            </div>
            <el-container style="height: 620px; margin-top: 10px">
                <el-aside height="100%" style="width: 400px; transition: all 0.3s; margin-bottom: 10px">
                    <el-card class="box-card" style="padding: 10px; height: 100%; overflow: auto">
                        <previewPicture :imgUrl="picUrl" :hotPoints="hotPoints" @findOeInTB="findOeInTB"></previewPicture>
                    </el-card>
                </el-aside>
                <el-main height="100%" style="padding-top: 0px; padding-bottom: 0px; transition: all 0.3s; margin-bottom: 10px">
                    <div class="table-ctn">
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="tableData"
                            ref="oeTable"
                            border=""
                            style="width: 100%; height: 570px; overflow: auto"
                        >
                            <el-table-column width="80px" prop="OrderNo" label="位置序号" show-overflow-tooltip></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="StdPartName" label="零件名称"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="Oe" label="零件号（OE）">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.LoadMyOe" icon="el-icon-loading" type="text"></el-button>
                                    <el-popover placement="right" v-model="scope.row.visible" :ref="'pop1_' + scope.row.OEId">
                                        <el-table
                                            class="pop-tb"
                                            style="margin-bottom: 0px"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            border=""
                                            :data="scope.row.MyGoods"
                                        >
                                            <el-table-column show-overflow-tooltip min-width="140" property="APCode" label="编码">
                                                <template slot-scope="scope">
                                                    <el-button class="pop-btn" icon="el-icon-plus" type="round" @click="addToPreOrder(scope.row)"></el-button>
                                                    {{ scope.row.APCode }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column show-overflow-tooltip min-width="100" property="GoodCode" label="互换码"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Origin" label="产地"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Inventory" label="库存数"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="MarketPrice" label="销售价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="CostPrice" label="成本价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingInQuantity" label="待入"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingOutQuantity" label="待出"></el-table-column>
                                        </el-table>
                                        <el-button
                                            class="pop-btn"
                                            type="primary"
                                            slot="reference"
                                            @click="showMyOE(scope.row)"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            >有货</el-button
                                        >
                                    </el-popover>
                                    {{ scope.row.Oe }}
                                </template>
                            </el-table-column>
                            <el-table-column v-if="showOEPrice" show-overflow-tooltip width="170px" label="价格">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.PriceData && scope.row.IsShow" placement="right">
                                        <div slot="content" v-html="$options.filters.priceShowText(scope.row.PriceData)"></div>
                                        <span>{{ scope.row.PriceData.GuidePrice }}</span>
                                    </el-tooltip>
                                    <span v-else>
                                        <el-button @click="getPrices(scope.row)" type="text" style="padding: 0px">获取价格</el-button>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="80px" prop="PartNum" label="装备数量"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="PartRemark" label="更多信息"></el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </el-container>
        </div>
        <div v-if="showModel == 'epcOeResultData'">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-back" class="back-btn btn-primary" @click="backToImg">返回</el-button>
                    <div class="title">搜索内容【 {{ oeStr }} 】</div>
                </div>
            </div>
            <el-container style="height: 620px; margin-top: 10px">
                <el-main height="100%" style="padding: 0px; transition: all 0.3s; margin-bottom: 10px">
                    <div class="table-ctn">
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="oeResults"
                            ref="oeTable"
                            border=""
                            style="width: 100%; height: 570px; overflow: auto"
                        >
                            <el-table-column width="80px" prop="OrderNo" label="位置序号" show-overflow-tooltip></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="StdPartName" label="零件名称"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="Oe" label="零件号（OE）">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.LoadMyOe" icon="el-icon-loading" type="text"></el-button>
                                    <el-popover placement="right" v-model="scope.row.visible" :ref="'pop2_' + scope.row.OEId">
                                        <el-table
                                            class="pop-tb"
                                            style="margin-bottom: 0px"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            border=""
                                            :data="scope.row.MyGoods"
                                        >
                                            <el-table-column show-overflow-tooltip min-width="120" property="APCode" label="编码">
                                                <template slot-scope="scope">
                                                    <el-button class="pop-btn" icon="el-icon-plus" type="round" @click="addToPreOrder(scope.row)"></el-button>
                                                    {{ scope.row.APCode }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column show-overflow-tooltip min-width="100" property="GoodCode" label="互换码"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Origin" label="产地"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Inventory" label="库存数"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="MarketPrice" label="销售价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="CostPrice" label="成本价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingInQuantity" label="待入"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingOutQuantity" label="待出"></el-table-column>
                                        </el-table>
                                        <el-button
                                            class="pop-btn"
                                            type="primary"
                                            slot="reference"
                                            @click="showMyOEResult(scope.row)"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            >有货</el-button
                                        >
                                    </el-popover>
                                    {{ scope.row.Oe }}
                                </template>
                            </el-table-column>
                            <el-table-column v-if="showOEPrice" show-overflow-tooltip width="170px" label="价格">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.PriceData && scope.row.IsShow" placement="right">
                                        <div slot="content" v-html="$options.filters.priceShowText(scope.row.PriceData)"></div>
                                        <span>{{ scope.row.PriceData.GuidePrice }}</span>
                                    </el-tooltip>
                                    <span v-else>
                                        <el-button @click="getPrices(scope.row)" type="text" style="padding: 0px">获取价格</el-button>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="170px" label="图号">
                                <template slot-scope="scope">
                                    <el-button @click="gotoPicMode(scope.row)" type="text" style="padding: 0px">{{ scope.row.PicNo }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column v-show="isVipUser" show-overflow-tooltip width="80px" prop="IsFitVeh" label="是否适配"></el-table-column>
                            <el-table-column show-overflow-tooltip width="80px" prop="PartNum" label="装备数量"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="PartRemark" label="更多信息"></el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </el-container>
        </div>
        <div v-if="showModel == 'oeJzymResultData'">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-back" class="back-btn btn-primary" @click="backToImg">返回</el-button>
                    <div class="title">搜索内容【 {{ oeStr }} 】</div>
                </div>
            </div>
            <el-container style="height: 620px; margin-top: 10px">
                <el-main height="100%" style="padding: 0px; transition: all 0.3s; margin-bottom: 10px">
                    <div class="table-ctn">
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="oeJzymResults"
                            ref="oeTable"
                            border=""
                            style="width: 100%; height: 570px; overflow: auto"
                        >
                            <el-table-column show-overflow-tooltip min-width="120px" prop="StdPartName" label="标准零件名称"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="Oe" label="零件号（OE）">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.LoadMyOe" icon="el-icon-loading" type="text"></el-button>
                                    <el-popover placement="right" v-model="scope.row.visible" :ref="'pop2_' + scope.row.StdPartId">
                                        <el-table
                                            class="pop-tb"
                                            style="margin-bottom: 0px"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            border=""
                                            :data="scope.row.MyGoods"
                                        >
                                            <el-table-column show-overflow-tooltip min-width="120" property="APCode" label="编码">
                                                <template slot-scope="scope">
                                                    <el-button class="pop-btn" icon="el-icon-plus" type="round" @click="addToPreOrder(scope.row)"></el-button>
                                                    {{ scope.row.APCode }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column show-overflow-tooltip min-width="100" property="GoodCode" label="互换码"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Origin" label="产地"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="Inventory" label="库存数"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="MarketPrice" label="销售价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="CostPrice" label="成本价"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingInQuantity" label="待入"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="80" property="WaitingOutQuantity" label="待出"></el-table-column>
                                        </el-table>
                                        <el-button
                                            class="pop-btn"
                                            type="primary"
                                            slot="reference"
                                            @click="showMyOEResult(scope.row)"
                                            v-if="scope.row.MyGoods && scope.row.MyGoods.length > 0"
                                            >有货</el-button
                                        >
                                    </el-popover>
                                    {{ scope.row.Oe }}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip min-width="80px" prop="OEName" label="原厂零件名称"></el-table-column>
                            <el-table-column show-overflow-tooltip min-width="120px" prop="GuidePrice" label="指导价"></el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import previewPicture from '@/components/common/previewPicture.vue';
export default {
    mixins: [],
    props: {
        vehicleId: String,
        vin: String
    },
    components: { previewPicture },
    data() {
        return {
            structureList: [],
            structureImgList: [],
            downloadUrl: this.$util.QN_URL_BASE,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            filterText: '',
            searchData: {
                vehicleId: this.vehicleId,
                notLeave: false
            },
            loading: false,
            treeProps: {
                children: 'Childrens',
                label: 'ParentName'
            },
            oeTitle: '',
            oeDataVisible: false,
            oePicNo: '',
            showOEPrice: false,
            showModel: 'epcImg',
            oeShowTitle: '',
            picUrl: '',
            tableData: [],
            hotPoints: [],
            selectOrderNo: '',
            sourceDataList: [],
            oeStr: '',
            searchMode: '0',
            oeResults: [],
            currentIndex: -1,
            partGroupId: '',
            oeNoImgData: [],
            oeJzymResults: [],
            isVipUser: false
        };
    },
    filters: {
        priceShowText(x) {
            if (x) {
                let str = '厂商指导价：' + x.GuidePrice + '<br/>';
                str += '华南区市场价：' + x.MarketPriceHn + '<br/>';
                str += '华东区市场价：' + x.MarketPriceHd + '<br/>';
                str += '西部区市场价：' + x.MarketPriceXb + '<br/>';
                str += '东北区市场价：' + x.MarketPriceDb + '<br/>';
                str += '华北区市场价：' + x.MarketPriceHb + '<br/>';
                return str;
            } else {
                return x;
            }
        },
        InvenShowText(x) {
            if (x.length > 0) {
                let str = '';
                x.forEach(good => {
                    str += good.APCode + (good.GoodCode ? ' 【 互换码：' + good.GoodCode + ' 】' : '') + '  库存：' + good.Inventory + '<br/>';
                });
                return str;
            } else {
                return x;
            }
        },
        xSplitText(x) {
            if (~x.indexOf(',')) {
                return x.split(',')[0];
            } else {
                return x;
            }
        },
        ySplitText(x) {
            if (~x.indexOf(',')) {
                return x.split(',')[1];
            } else {
                return x;
            }
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    mounted() {
        let mode = this.$util.getLocalStorage('oesearch_mode');
        if ((mode && mode == 0) || mode == 1) {
            this.searchMode = mode;
        }

        this.GetStructures();
    },
    methods: {
        GetStructures() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/Auto/GetStructures',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.structureList = res.data;
                        let sIdx = this.structureList.findIndex(f => f.IsLeaf);
                        if (sIdx > -1) {
                            let partGroupId = this.structureList[sIdx].Id;
                            if (partGroupId) this.getFirstNode(partGroupId);
                        } else {
                            if (this.structureList[0]) {
                                sIdx = this.structureList[0].Childrens.findIndex(f => f.IsLeaf);
                                if (sIdx > -1) {
                                    let partGroupId = this.structureList[0].Childrens[sIdx].Id;
                                    if (partGroupId) this.getFirstNode(partGroupId);
                                }
                            }
                        }
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                    this.getConfigByCodes();
                });
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.ParentName.indexOf(value) !== -1;
        },
        getFirstNode(partGroupId) {
            if (partGroupId) {
                this.loading = true;
                this.partGroupId = partGroupId;
                this.$util
                    .axiosGet({
                        url: '/api/Auto/GetStructureImgs',
                        data: {
                            vehicleId: this.vehicleId,
                            partGroupId: partGroupId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.structureImgList = res.data;
                        } else {
                            this.structureImgList = [];
                            this.$util.warningMsg(res.errmsg);
                            this.getOEDataButNoImg();
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleNodeClick(data, node, VueComponent) {
            if (data && data.IsLeaf) {
                this.loading = true;
                this.partGroupId = data.Id;
                this.$util
                    .axiosGet({
                        url: '/api/Auto/GetStructureImgs',
                        data: {
                            vehicleId: this.vehicleId,
                            partGroupId: data.Id
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.structureImgList = res.data;
                        } else {
                            this.structureImgList = [];
                            this.$util.warningMsg(res.errmsg);
                            this.getOEDataButNoImg();
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        gotoDetails(item, index) {
            let that = this;
            if (item) {
                that.currentIndex = index;
                that.oeTitle = item.PicName + ' 【' + item.PicNo + '】';
                that.oePicNo = item.PicNo;
                that.picUrl = item.CHJImgUrl
                    ? that.downloadUrl + (item.CHJImgUrl.length > 0 ? item.PublicUrl : '/UploadFile/Commons/Public/Images/200x200.png')
                    : item.PicUrl;
                that.showModel = 'epcOeData';
                that.getTableData();
            }
        },
        getOEDataButNoImg() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetOEDataButNoImgs',
                    data: { vehicleId: that.vehicleId, partGroupId: that.partGroupId, vin: that.vin },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadMyOe = true;
                    }

                    that.oeNoImgData = data;
                    that.getMyOEDatas2(that.oeNoImgData);
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        async getMyOEDatas2(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData2(data[i].Oe, data[i].OEId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData2(oe, oeId) {
            let that = this;
            let url = '/api/Auto/GetMyOEDatas';
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        oe: oe,
                        oeId: oeId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.oeNoImgData.forEach(item => {
                        if (item.OEId == oeId) {
                            item.LoadMyOe = false;
                            item.MyGoods = data.MyGoods;
                            item.IsShow = data.IsShow;
                            return;
                        }
                    });
                })
                .catch(() => {
                    that.oeNoImgData.forEach(item => {
                        if (item.OEId == oeId) {
                            item.LoadMyOe = false;
                            return;
                        }
                    });
                });
        },
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetOEDatas',
                    data: { vehicleId: that.vehicleId, picNo: that.oePicNo, vin: that.vin },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadMyOe = true;
                    }

                    that.tableData = data;
                    that.sourceDataList = data;
                    that.getPicHotPointDatas();
                    that.getMyOEDatas(that.tableData);
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        getPrices(row) {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetOEPriceDatas',
                    data: { oeId: row.OEId },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (data) {
                        if (that.showModel != 'epcOeResultData') {
                            that.tableData.forEach(oe => {
                                if (oe.OEId == row.OEId) {
                                    oe.IsShow = true;
                                    oe.PriceData = data;
                                    return;
                                }
                            });
                            that.sourceDataList.forEach(oe => {
                                if (oe.OEId == row.OEId) {
                                    oe.IsShow = true;
                                    oe.PriceData = data;
                                    return;
                                }
                            });
                        } else {
                            that.oeResults.forEach(oe => {
                                if (oe.OEId == row.OEId) {
                                    oe.IsShow = true;
                                    oe.PriceData = data;
                                    return;
                                }
                            });
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getPicHotPointDatas() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetPicHotPointDatas',
                    data: { vehicleId: that.vehicleId, picNo: that.oePicNo },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];

                    that.hotPoints = data;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        async getMyOEDatas(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].Oe, data[i].OEId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData(oe, oeId) {
            let that = this;
            let url = '/api/Auto/GetMyOEDatas';
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        oe: oe,
                        oeId: oeId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (that.showModel != 'epcOeResultData') {
                        that.tableData.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                item.MyGoods = data.MyGoods;
                                item.IsShow = data.IsShow;
                                return;
                            }
                        });
                        that.sourceDataList.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                item.MyGoods = data.MyGoods;
                                item.IsShow = data.IsShow;
                                return;
                            }
                        });
                    } else {
                        that.oeResults.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                item.MyGoods = data.MyGoods;
                                item.IsShow = data.IsShow;
                                return;
                            }
                        });
                    }
                })
                .catch(() => {
                    if (that.showModel != 'epcOeResultData') {
                        that.tableData.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                return;
                            }
                        });
                        that.sourceDataList.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                return;
                            }
                        });
                    } else {
                        that.oeResults.forEach(item => {
                            if (item.OEId == oeId) {
                                item.LoadMyOe = false;
                                return;
                            }
                        });
                    }
                });
        },
        backToImg() {
            this.showModel = 'epcImg';
            this.picUrl = '';
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['epcljzsjg', 'vipcuswxbxsh'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'epcljzsjg':
                                    this.showOEPrice = result;
                                    break;
                                case 'vipcuswxbxsh':
                                    this.isVipUser = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        rollImg() {
            /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
            var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
            /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
            zoom += event.wheelDelta / 12;
            console.log(zoom);
            /* 最小范围 和 最大范围 的图片缩放尺度 */
            if (zoom >= 100 && zoom < 500) {
                this.$refs.imgDiv.style.zoom = zoom + '%';
            }
            return false;
        },
        addToPreOrder(row) {
            let goods = {
                Id: row.Id,
                GoodName: row.GoodName,
                APCode: row.APCode,
                MarketPrice: row.MarketPrice,
                GoodCode: row.GoodCode,
                Inventory: row.Inventory,
                AutoSerise: row.AutoSerise,
                CostPrice: row.CostPrice,
                Size: row.Size,
                Origin: row.Origin,
                Unit: row.Unit,
                Count: 1,
                PreCount: 1,
                IsEdit: false,
                IsCheck: false
            };
            let data = this.$util.getLocalStorage('preOrderGoodsList');
            if (data) {
                let isHad = false;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].Id == goods.Id) {
                        isHad = true;
                        data[i].Count += 1;
                        data[i].PreCount += 1;
                    }
                }
                if (!isHad) data.push(goods);
            } else {
                data = [];
                data.push(goods);
            }
            this.$util.setLocalStorage('preOrderGoodsList', data);
            this.$store.commit('updateShowPreOrder', data.length);
            this.$util.successMsg('成功加入待售');
        },
        findOeInTB(item) {
            if (this.selectOrderNo == item.OrderNo) {
                this.selectOrderNo = '';
                this.tableData = this.sourceDataList;
            } else {
                let dataList = this.sourceDataList.filter(f => f.OrderNo == item.OrderNo);
                this.tableData = dataList;
                this.selectOrderNo = item.OrderNo;
            }
        },
        handleSearch() {
            let that = this;
            if (!that.oeStr) {
                that.$util.warningMsg('请输入搜索内容');
                return;
            }
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetOEDatasByKey',
                    data: { searchMode: that.searchMode, oeStr: that.oeStr, vehicleId: that.vehicleId, vin: that.vin },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) {
                        data = [];
                        that.$util.warningMsg('未检索到相关零件');
                    } else {
                        that.showModel = 'epcOeResultData';
                        that.oeResults = data;
                        that.getMyOEDatas(that.oeResults);
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        jzymSearch() {
            let that = this;
            if (!that.oeStr) {
                that.$util.warningMsg('请输入搜索内容');
                return;
            }
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetOEDatasByJZYM',
                    data: { oeStr: that.oeStr, vehicleId: that.vehicleId, vin: that.vin },
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) {
                        data = [];
                        that.$util.warningMsg('未检索到相关零件');
                    } else {
                        that.showModel = 'oeJzymResultData';
                        that.oeJzymResults = data;
                        that.getMyOEDatas3(that.oeJzymResults);
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        async getMyOEDatas3(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData2(data[i].Oe, data[i].OEId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData3(oe, oeId) {
            let that = this;
            let url = '/api/Auto/GetMyOEDatas';
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        oe: oe,
                        oeId: oeId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.oeJzymResults.forEach(item => {
                        if (item.OEId == oeId) {
                            item.LoadMyOe = false;
                            item.MyGoods = data.MyGoods;
                            return;
                        }
                    });
                })
                .catch(() => {
                    that.oeJzymResults.forEach(item => {
                        if (item.OEId == oeId) {
                            item.LoadMyOe = false;
                            return;
                        }
                    });
                });
        },
        gotoPicMode(row) {
            let that = this;
            that.currentIndex = -1;
            that.showModel = 'epcOeData';
            this.oePicNo = row.PicNo;
            this.getTableData();
            this.getPic();
        },
        getPic() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/Auto/GetPicUrlByPicNo',
                    data: { vehicleId: that.vehicleId, picNo: that.oePicNo },
                    hideLoading: true
                })
                .then(res => {
                    that.picUrl = res.data;
                })
                .catch(() => {});
        },
        lastPic() {
            let that = this;
            if (that.currentIndex > 0 && that.structureImgList && that.structureImgList.length != 1) {
                that.currentIndex -= 1;
                let item = that.structureImgList[that.currentIndex];
                that.gotoDetails(item, that.currentIndex);
            }
        },
        nextPic() {
            let that = this;
            if (that.structureImgList && that.structureImgList.length != 1 && that.currentIndex < that.structureImgList.length) {
                that.currentIndex += 1;
                let item = that.structureImgList[that.currentIndex];
                that.gotoDetails(item, that.currentIndex);
            }
        },
        showMyOE(row) {
            row.visible = !row.visible;
            this.$refs['pop1_' + row.OEId].updatePopper();
        },
        showMyOEResult(row) {
            row.visible = !row.visible;
            this.$refs['pop2_' + row.OEId].updatePopper();
        },
        modeChange(value) {
            this.$util.setLocalStorage('oesearch_mode', value);
        }
    }
};
</script>
<style lang="less" scoped>
.search-zone {
    display: flex;
    flex-direction: row;
}

.pop-btn {
    padding: 2px !important;
}

.search-ctn {
    margin-top: 10px;
}

.search-ctn-left {
    display: flex;
    flex-direction: row;
    align-items: center;

    .title {
        font-size: 20px;
        margin-left: 10px;
    }
}

.img-zone {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: auto;
}

.err-title {
    width: 200px;
    height: 100px;
}

.tu-item {
    width: 218px;
    height: 258px;
    margin-right: 10px;
    margin-bottom: 10px;

    &:hover {
        border: 1px solid @theme;
    }

    .qp-cover {
        position: relative;
        width: 218px;
        height: 218px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 218px;
            max-height: 218px;
            overflow: hidden;
        }
    }
}

.tu-msg {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
        padding-top: 10px;
    }

    .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
<style lang="less">
.el-table .warning-row {
    background: pink !important;
}

.pop-tb {
    .el-table__body {
        .el-table__row {
            .cell {
                button {
                    padding: 0;
                }
            }

            td {
                padding: 6px 0 !important;
            }
        }
    }

    th {
        padding: 6px 0 !important;
    }

    margin-bottom: 34px;

    .el-table__footer-wrapper {
        .el-table__footer td {
            padding: 4px 0 4px 0;
        }
    }
}
</style>
